import Icon from 'components/Icon'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetchOrder, useOrder } from 'state/Orders'
import { getLoading } from 'state/Request'
import { klass, usePlainEffect } from 'utils'
import OrderContext from './_context'
import BasicOrder from './BasicOrder'
import CompleteOrder from './CompleteOrder'
import './styles.scss'

export default function OrderPage() {
	const { t }    = useTranslation()
	const { id }   = useParams()
	const dispatch = useDispatch()
	const loading  = useSelector(getLoading('order'))

	usePlainEffect(() => dispatch(fetchOrder(id)), [id, dispatch])
	const [order, isTemp] = useOrder(id)

	const title = <>
		<span className="d-none d-print-inline-block">{t('Order')}&nbsp;</span>
		<span {...klass('order-symbol', { textMuted: !loading })}>
			{loading? <Icon i="refresh" spin className="mx-n2"/> : '#'}
		</span>&nbsp;
		{order.number?
			<span {...klass('order-number', { textMuted: loading })}>{order.number}</span> :
			t('Loading order')}
	</>

	const pageTitle = order.number? t('#{{order}} for {{customer}}', {
		order   : order.number,
		customer: order.customer_name,
	}) : t('Loading order details...')

	const OrderDetails = isTemp? BasicOrder : CompleteOrder
	return <OrderContext.Provider value={order}>
		<OrderDetails {...{ title, pageTitle }}/>
	</OrderContext.Provider>
}
